module.exports = __webpack_public_path__ + "img/ic-checkmark-warning.9ade73bb.svg";